import { render, staticRenderFns } from "./AdminRealEstateDevelopmentQuoteView.vue?vue&type=template&id=f4b8b4c4&scoped=true"
import script from "./AdminRealEstateDevelopmentQuoteView.vue?vue&type=script&lang=js"
export * from "./AdminRealEstateDevelopmentQuoteView.vue?vue&type=script&lang=js"
import style0 from "./AdminRealEstateDevelopmentQuoteView.vue?vue&type=style&index=0&id=f4b8b4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b8b4c4",
  null
  
)

export default component.exports